import { RootState } from '../../../../utils/type';

export const selectChargerStatus = (state: RootState) => state.chargerStatus.data;
export const selectChargerStatusLoading = (state: RootState) => state.chargerStatus.loading;
export const selectChargerStatusError = (state: RootState) => state.chargerStatus.error;
